import QASAddressLookUp from './QASAddressLookUp';
export { QASAddressLookUp as default };
